import React, { useState,useEffect } from "react";
import axios from "axios";
import Resetpassword_page1 from "../assets/img/Resetpassword_page1.png";
import { OverlayTrigger, Popover, Button } from "react-bootstrap";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import Password from "../assets/img/Password.png";
const Changepassword = () => {
  const [passwords, setPasswords] = useState({
    old_password: "",
    new_password: "",
    confirm_password: "",
  });
  const [showPassword, setShowPassword] = useState({
    old: false,
    new: false,
    confirm: false,
  });
  const [errors, setErrors] = useState("");
  const [status, setStatus] = useState({});
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const handleChange = (e) => {
    setPasswords({ ...passwords, [e.target.name]: e.target.value });
  };
const [placement, setPlacement] = useState("top");
  const togglePopover = () => setShow(!show);
  const popover = (
    <Popover id="info-popover">
      <Popover.Header as="h3">Password Policy</Popover.Header>
      <Popover.Body>
        New Password should contain minimum 8 Characters with
        Uppercase,Lowercase and Numbers
      </Popover.Body>
      <Popover.Body>
        New Password and Confirm Password should be same.
      </Popover.Body>
    </Popover>
  );
  const togglePassword = (field) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };
  const passwordValidator = (new_password) => {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).*$/;
    return passwordRegex.test(new_password);
  };
  const validatePasswords = () => {
    const errorMsg = {};
    if (!passwords.old_password.trim()) {
      errorMsg.old_password = "Old password is required";
    }

    if (!passwords.new_password.trim()) {
      errorMsg.new_password = "New password is required";
    } else if (!passwordValidator(passwords.new_password)) {
      errorMsg.new_password =
        "New Password should contain minimum 8 characters with Uppercase, Lowercase and numbers";
    }

    if (!passwords.confirm_password.trim()) {
      errorMsg.confirm_password = "Confirm password is required";
    } else if (passwords.new_password !== passwords.confirm_password) {
      errorMsg.confirm_password = "Passwords do not match";
    }
    setErrors(errorMsg);
    return Object.keys(errorMsg).length === 0;
  };
  const handleChangePwdLogout = () => {
    sessionStorage.removeItem("token");
    navigate("/login");
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validatePasswords()) return;
    setLoading(true);
    try {
      const token = sessionStorage.getItem("token");
      const changePwd = await axios.post("/change-password", passwords, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("changePwd:", changePwd);
      const resultData = changePwd.data;
      console.log(resultData);
      if (resultData.response_code === 200) {
        setStatus({
          response_code: resultData.response_code,
          message: resultData.message,
        });
      }
      if (resultData.response_code === 400) {
        setStatus({
          response_code: resultData.response_code,
          message: resultData.message,
        });
      }
      if (resultData.response_code === 422) {
        setStatus({
          response_code: resultData.response_code,
          message: resultData.message,
        });
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
useEffect(() => {
  const updatePlacement = () => {
    setPlacement(window.innerWidth >= 575 ? "right" : "bottom");
  };

  updatePlacement(); // set on initial load

  window.addEventListener("resize", updatePlacement);
  return () => window.removeEventListener("resize", updatePlacement);
}, []);
  return (
    <div className="container-fluid px-0">
      <div className="row d-flex justify-content-center align-items-center g-0 changepwd-container">
        <div className="col-12 col-md-6 changepwd-image-col">
          <img
            src={Resetpassword_page1}
            alt="Resetpassword_page1"
            className="img-fluid"
          ></img>
        </div>
        <div className="col-12 col-md-6 changepwd-form-col">
          <div className="changepwd-content">
            <p className="changepwd-title d-flex align-items-center gap-2">
              Change Password
              <OverlayTrigger
                trigger={["hover", "click", "focus"]}
                placement={placement}
                overlay={popover}
                onToggle={togglePopover}
                popperConfig={{
                  modifiers: [
                    { name: "offset", options: { offset: [0, 6] } }, // [skewX, skewY] — tweak Y value
                    {
                      name: "preventOverflow",
                      options: { boundary: "viewport" },
                    },
                  ],
                }}
                container={document.body} // render popover at body level to avoid parent stacking issues
                rootClose
              >
                <Button
                  variant="link"
                  className="changepwd-icon p-0 border-0 d-flex align-items-center justify-content-center text-align-justify"
                  style={{ lineHeight: 1 }}
                >
                  <IoMdInformationCircleOutline size={22} color="black" />
                </Button>
              </OverlayTrigger>
            </p>
            <div>
              <p className="changepwd-mandatory">
                <span className="text-danger">*</span>All Fields are Mandatory
              </p>
            </div>
            <form className="changepwd-form" onSubmit={handleSubmit}>
              {status.response_code && (
                <div
                  className="modal fade show"
                  style={{
                    display: "block",
                    backgroundColor: "rgba(0,0,0,0.5)",
                  }}
                  tabIndex="-1"
                  role="dialog"
                >
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <div
                        className={`modal-header ${
                          status.response_code === 200
                            ? "bg-primary text-white"
                            : "bg-primary text-white"
                        }`}
                      >
                        <h5 className="modal-title">Change Password</h5>
                      </div>

                      <div className="modal-body">
                        <p className="text-center">{status?.message}</p>
                      </div>

                      <div className="modal-footer">
                        {status.response_code === 200 ? (
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleChangePwdLogout}
                          >
                            Ok
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => setStatus("")}
                          >
                            Close
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="position-relative">
                <img
                  style={{ position: "absolute", top: "18px", left: "12px" }}
                  src={Password}
                  alt="Password"
                ></img>
                <input
                  type={showPassword.old ? "text" : "password"}
                  name="old_password"
                  value={passwords.old_password}
                  className="form-control px-5 py-3 mb-2"
                  onChange={handleChange}
                  placeholder="Enter your Old password"
                ></input>
                <span
                  className="position-absolute end-0 top-0 mt-2 me-3"
                  onClick={() => togglePassword("old")}
                  style={{ cursor: "pointer" }}
                >
                  <i
                    className={`bi ${
                      showPassword.old ? "bi-eye" : "bi-eye-slash"
                    }`}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "22px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  />
                </span>
                {errors.old_password && (
                  <p className="text-danger small">{errors.old_password}</p>
                )}
              </div>
              <div className="position-relative">
                <img
                  style={{ position: "absolute", top: "18px", left: "12px" }}
                  src={Password}
                  alt="Password"
                ></img>
                <input
                  type={showPassword.new ? "text" : "password"}
                  name="new_password"
                  value={passwords.new_password}
                  className=" form-control px-5 py-3 mb-2"
                  onChange={handleChange}
                  placeholder="Enter your New password"
                ></input>
                <span
                  className="position-absolute end-0 top-0 mt-2 me-3"
                  onClick={() => togglePassword("new")}
                  style={{ cursor: "pointer", zIndex: 2 }}
                >
                  <i
                    className={`bi ${
                      showPassword.new ? "bi-eye" : "bi-eye-slash"
                    }`}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "22px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  />
                </span>
                {errors.new_password && (
                  <p className="text-danger small">{errors.new_password}</p>
                )}
              </div>
              <div className="position-relative">
                <img
                  style={{ position: "absolute", top: "18px", left: "12px" }}
                  src={Password}
                  alt="password"
                ></img>
                <input
                  type={showPassword.confirm ? "text" : "password"}
                  name="confirm_password"
                  value={passwords.confirm_password}
                  className=" form-control px-5 py-3 mb-2"
                  onChange={handleChange}
                  placeholder="Enter your Confirm password"
                ></input>
                <span
                  className="position-absolute end-0 top-0 mt-2 me-3"
                  onClick={() => togglePassword("confirm")}
                  style={{ cursor: "pointer" }}
                >
                  <i
                    className={`bi ${
                      showPassword.confirm ? "bi-eye" : "bi-eye-slash"
                    }`}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "22px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  />
                </span>
                {errors.confirm_password && (
                  <p className="text-danger small">{errors.confirm_password}</p>
                )}
              </div>
              <div className="d-flex justify-content-center">
                <button
                  type="submit"
                  className="btn btn-primary mt-4 w-50"
                  onClick={handleSubmit}
                >
                  {loading ? (
                    <div className="spinner-border text-light" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : (
                    "Set Password"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Changepassword;
